// The header row lives outside .lr-scroll so it can use true position:sticky
// against the page viewport (see lot-release-styles.blade.php for why). Since
// it's no longer part of the scrolling row content, its horizontal position
// has to be mirrored from .lr-scroll by hand.
const assayTables = document.querySelectorAll(".lr-assay-table");

assayTables.forEach((table) => {
  const headWrap = table.querySelector(".lr-head-main-wrap");
  const body = table.querySelector(".lr-scroll");
  if (!headWrap || !body) return;

  body.addEventListener(
    "scroll",
    () => {
      headWrap.scrollLeft = body.scrollLeft;
    },
    { passive: true }
  );
});
